module.exports = __webpack_public_path__ + "img/eu1.ea78c18b.jpg";